import React from 'react';
import { StyleProp, TextStyle } from 'react-native';
import useCustomTheme from '../../hooks/theme-hook';
import Label, { LabelType } from './Label';

export interface FieldErrorMessageProps {
  message?: string;
  style?: StyleProp<TextStyle>;
  numberOfLines?: number;
}

const FieldErrorMessage = (props: FieldErrorMessageProps) => {
  const theme = useCustomTheme();

  if (!props.message) {
    return null;
  }

  const color = theme.isDark ? (theme.text.error?.toString() ?? '#ff9bb4') : (theme.colorErrorPrimary?.toString() ?? '#8e183d');

  return (
    <Label
      variant={LabelType.body1}
      numberOfLines={props.numberOfLines ?? 5}
      style={[
        {
          color,
          marginTop: 8,
          backgroundColor: 'transparent',
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          fontWeight: '600',
        },
        props.style,
      ]}
    >
      {props.message}
    </Label>
  );
};

export default FieldErrorMessage;
